import { getSignedUrl } from './uploadImage'

export interface DeleteImageInput {
  url: string
  location: 'events' | 'entries'
  jwtToken: string
}

export async function deleteImage(input: DeleteImageInput): Promise<void> {
  const { url, location, jwtToken } = input

  const indicator = 'cloudfront.net/'
  const index = url.lastIndexOf(indicator)
  const key = `${url.slice(index + indicator.length)}.jpg`
  console.log('key', key)

  const signedUrl = await getSignedUrl(
    { key, location, action: 'delete' },
    jwtToken,
  )

  try {
    const response = await fetch(signedUrl, {
      method: 'DELETE',
    })

    if (!response.ok) {
      throw new Error(`${response.status} is not ok`)
    }

    return
  } catch (err) {
    if (err instanceof Error) {
      throw new Error(`Error deleting image ${err.message}`)
    }
    console.error('Error deleting image', err)
    throw err
  }
}
